import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDownloadhGuaranteeLetter, fetchGuaranteeLetters } from './actions/fetch-guarantee-letter';
import { IGuaranteeLetter, IGuaranteeLettersState, TError } from './types/GuaranteeLetter- interface';

export const initialCaseState = {
    ID: "",
    Date: "",
    StatusName: "",
    RequestTypeName: "",
    HospitalFullName: "",
};

const initialState: IGuaranteeLettersState = {
    GuaranteeLetters: [],
    isLoadingGuaranteeLetters: false,
    errorGuaranteeLetters: [],
    lastFetchTimeGuaranteeLetters: null,
    PolicyID: null,
    currentPageInCase: 1,
    FileData: "",
    FileName: "",
    isDownload: false,
    errorDownload: []

};

export const GuaranteeLettersList = createSlice({
    name: 'GuaranteeLettersList',
    initialState,
    reducers: {
        resetGuaranteeLettersData: (state) => {
            state.isLoadingGuaranteeLetters = false;
            state.GuaranteeLetters = [];
            state.errorGuaranteeLetters = [];
            state.lastFetchTimeGuaranteeLetters = null;
            state.PolicyID = null;
            state.FileData = "";
            state.FileName = "";
        },
        setCurrentPageInCaseGuaranteeLetters: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPageInCase = action.payload.page;
        },
        resetFile: (state) => {
            state.FileData = "";
            state.FileName = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGuaranteeLetters.pending, (state) => {
                state.isLoadingGuaranteeLetters = true;

            })
            .addCase(fetchGuaranteeLetters.fulfilled, (state, action: PayloadAction<{ GuaranteeLetters: IGuaranteeLetter[], PolicyID: string, fetchTime: number }>) => {
                state.isLoadingGuaranteeLetters = false;
                state.GuaranteeLetters = action.payload.GuaranteeLetters;
                state.errorGuaranteeLetters = [];
                state.lastFetchTimeGuaranteeLetters = action.payload.fetchTime;
                state.PolicyID = action.payload.PolicyID;
            })
            .addCase(fetchGuaranteeLetters.rejected, (state, action) => {
                state.GuaranteeLetters = [];
                state.isLoadingGuaranteeLetters = false;
                state.lastFetchTimeGuaranteeLetters = null;
                state.errorGuaranteeLetters = action.payload as string[];
            })
            .addCase(fetchDownloadhGuaranteeLetter.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchDownloadhGuaranteeLetter.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownload = [];
            })
            .addCase(fetchDownloadhGuaranteeLetter.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownload = false;
                state.errorDownload = action.payload as TError;
            });
    },
});

export const { resetGuaranteeLettersData, setCurrentPageInCaseGuaranteeLetters, resetFile } = GuaranteeLettersList.actions;

export default GuaranteeLettersList.reducer;